import * as Sentry from '@sentry/react';
import { get, isArray } from 'lodash';
import { API_TITLES, METHOD_TITLES } from '../../consts/errors';

export const serializeError = error => {
  if (!error || !error.funcName) return null;

  const funcName = METHOD_TITLES[error.funcName] || error.funcName;
  const title = `Ошибка в ${funcName}`;

  // Временный костыль для логирования ошибки с сокетами
  if (funcName === METHOD_TITLES.subscribeSocketTickets)
    Sentry.captureException(JSON.stringify(error));

  return {
    title,
    message: error.message,
    createdAt: Math.round(new Date().getTime() / 1000),
  };
};

export const serializeServerError = error => {
  if (!error || !error.url) return null;

  const { url, loadTime } = error;

  const path = url.replace(process.env.API_HOST_URL, '').split('?')[0];
  const pathTitle = API_TITLES[path] || path;
  const tooSlowLabel =
    loadTime && `больше ${((loadTime / 1000) % 60).toFixed(1)} сек`;
  const title = `Запрос ${pathTitle} ${tooSlowLabel || 'не выполнился'}`;

  return {
    title,
    message: get(error, 'data.errors[0].message') || get(error, 'text') || null,
    url,
    createdAt: Math.round(new Date().getTime() / 1000),
  };
};

export const serializeErrors = errors => {
  if (!isArray(errors) && errors.length < 1) return null;

  return errors.map(error => serializeError(error));
};
